import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Input, Icon, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { Container, Title, PropertiesContainer, UplaodView, UploadButton } from './styles';
import BulkFontUploadModal from '../../components/Modals/BulkFontUploadModal';
import { TickIcon } from '../../images/svgIcons';
import { scrollToElement } from '../../utils/javascript';
import { ApplyFontConfirmation } from './styles';

// toolbar context API
import UploadFontModal from '../../components/Modals/UploadFontModal';
import { FONTS_SETTINGS_SIDEBAR } from './translationValues';
import { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';

const NAMESPACES = ['FONTS_SETTINGS_SIDEBAR']
const FontListToolbar = props => {
  const { fontList, font, onFontSave, style = {},isFromPortal,setFontChange, editor = undefined,CurrentDesign } = props;
  const ref = useRef(null);
  const selectedFont = useRef(null);
  const { t } = useTranslation(NAMESPACES);
  const [search, setSearch] = useState('');
  const [tabIndex, setTabIndex] = useState(-1);
  const [confirmFontChange, showConfirmFontChange] = useState(false);
  const [modalVisibility, setModalVisibility] = useState(false);
  const isOpenDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [isOpenDesign, updateArtboard] = useArtboardContext(isOpenDesignSelector, `FontList`);

  useEffect(() => {
    if (font) {
      scrollToElement(`font-${font}`, 'font-container', ref.current.scrollTop);
    }
  }, [font]);

  const onSearch = e => {
    setSearch(e.target.value);
  };

  const onFontSelect = fontDetails => {
    if (fontDetails.variants['bold'] && fontDetails.variants['italic'] && fontDetails.variants['bolditalic']) {
      setFontChange(fontDetails.name);
    } else {
      // TODO : Show confirmation box to erase any bold / italic formatting
      selectedFont.current = fontDetails.name;
      if (editor) {
        const quillEditor = editor?.current?.getEditor();
        const formats = quillEditor.getFormat();
        const keys = Object.keys(formats);
        if (keys.includes('bold') || keys.includes('italic')) {
          setFontChange(fontDetails.name);
          return;
        } else {
          showConfirmFontChange(true);
        }
      } else {
        showConfirmFontChange(true);
      }
    }
  };

  const renderSearchBar = () => {
    return (
      <Input
        name="fontsearch"
        placeholder={t(FONTS_SETTINGS_SIDEBAR.FONT_SEARCH_PLACEHOLDER.key, FONTS_SETTINGS_SIDEBAR.FONT_SEARCH_PLACEHOLDER.value)}
        size="large"
        value={search}
        onChange={onSearch}
        prefix={<Icon type="search" />}
        suffix={<>{<Icon type="close" onMouseDown={() => setSearch('')} />}</>}
        autoComplete={"off"}
      />
    );
  };
  const openModalHandler = id => {
    setTabIndex(id);
    setModalVisibility(true);
  };

 const uniqueFontList = Array.from(new Set(fontList?.map(fileObj => fileObj.name)))
 .map(name => {
   return fontList?.find(fileObj => fileObj.name === name)
 });

 function handleOpenDesign() {
     updateArtboard({ [CONTEXT_KEYS.SHOW_SIGNUP_PROMPT]: true })
 }

  return (
    <>
      <Container CurrentDesign={CurrentDesign}id="font-selection" onKeyDown={e => e.stopPropagation()} style={{...style, top: isFromPortal ? '10px' : style?.top }} display={1}>
        <Title>{renderSearchBar()}</Title>
        <PropertiesContainer id="font-container" ref={ref}>
          {uniqueFontList?.length > 0 && (
            <ul>
              {uniqueFontList.map(
                (data,index) => {
                  return (
                    <>
                      {data.name.toLowerCase().includes(search.toLocaleLowerCase()) && (
                        <li
                          id={`font-${data.name}`}
                          key={`${data.name+index}`}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            onFontSelect(data);
                          }}
                          style={{ fontFamily: data.name }}
                          value={data.value}
                        >
                          <span>{data.name}</span>
                          {data.name === font && (
                            <span>
                          <TickIcon />
                        </span>
                          )}
                        </li>
                      )}
                    </>
                  )
                },
              )}
            </ul>
          )}
        </PropertiesContainer>
        <UplaodView>
          <UploadButton onMouseDown={() => isOpenDesign ? handleOpenDesign() : setTabIndex(1)}>
            <Icon type="google" />
            {t(FONTS_SETTINGS_SIDEBAR.GOOGLE_FONTS_BUTTON.key, FONTS_SETTINGS_SIDEBAR.GOOGLE_FONTS_BUTTON.value)}
          </UploadButton>
          <UploadButton onMouseDown={() => isOpenDesign ? handleOpenDesign() : openModalHandler(2)}>
            <Icon type="upload" />
            {t(FONTS_SETTINGS_SIDEBAR.UPLOAD_FONTS_BUTTON.key, FONTS_SETTINGS_SIDEBAR.UPLOAD_FONTS_BUTTON.value)}
          </UploadButton>
        </UplaodView>
      </Container>
      {tabIndex === 1 && (
        <UploadFontModal
          fontList={fontList}
          tabIndex={tabIndex}
          onCancel={() => setTabIndex(-1)}
          onSucess={() => [onFontSave(), setTabIndex(-1)]}
        />
      )}
      {tabIndex === 2 && (
        <BulkFontUploadModal
          existFontList={fontList}
          visible={modalVisibility}
          onCancel={() => setModalVisibility(false)}
          onSucess={() => [onFontSave(), setTabIndex(-1)]}
        />
      )}
      {confirmFontChange && (
        <ApplyFontConfirmation
          width="640px"
          centered
          visible={true}
          closable={false}
          footer={[
              <Button
                label={t(FONTS_SETTINGS_SIDEBAR.CANCEL_LABEL.key, FONTS_SETTINGS_SIDEBAR.CANCEL_LABEL.value)}
                large={true}
                onClick={() => {
                  showConfirmFontChange(false);
                }}
              > {t(FONTS_SETTINGS_SIDEBAR.CANCEL_LABEL.key, FONTS_SETTINGS_SIDEBAR.CANCEL_LABEL.value)} </Button>,
              <Button
                 className={'cancel-button'}
                 label={t(FONTS_SETTINGS_SIDEBAR.CONTINUE_APPLY_FONT_LABEL.key, FONTS_SETTINGS_SIDEBAR.CONTINUE_APPLY_FONT_LABEL.value)}
                 large={true}
                 onClick={() => {
                   setFontChange(selectedFont.current);
                   showConfirmFontChange(false);
                 }}
               > {t(FONTS_SETTINGS_SIDEBAR.CONTINUE_APPLY_FONT_LABEL.key, FONTS_SETTINGS_SIDEBAR.CONTINUE_APPLY_FONT_LABEL.value)} </Button>
          ]}
        >
          <p style={{ marginTop: 20 }}>
          {t(FONTS_SETTINGS_SIDEBAR.FONT_APPLY_WARNING_TEXT.key, FONTS_SETTINGS_SIDEBAR.FONT_APPLY_WARNING_TEXT.value)}
          </p>
        </ApplyFontConfirmation>
      )}
    </>
  );
};

export default FontListToolbar;
